'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'duck';
var width = 512;
var height = 512;
var aliases = [129414];
var unicode = 'f6d8';
var svgPathData = 'M368 209.3l0 13.1 0 36.7 0 13.8 10 9.5c18.5 17.5 30 42.3 30 69.7c0 53-43 96-96 96l-120 0c-87.4 0-158.5-70.1-160-157.2l43.4 18.6 10.4 4.4 10.9-3 165-46.2 26.3-7.4 0-37.3-15.8-11.8C252.6 193.5 240 170.2 240 144c0-44.2 35.8-80 80-80s80 35.8 80 80c0 21.8-8.7 41.5-22.9 56l-9.1 9.3zM88 280L32 256 0 256l0 32C0 394 86 480 192 480l120 0c70.7 0 128-57.3 128-128c0-36.6-15.4-69.6-40-93l0-19 16 0c53 0 96-43 96-96l0-11 0-18.1-18 2.2-35.4 4.4c-9.6 1.2-19.3 1.1-28.9-.1C419.3 70.4 374.1 32 320 32c-61.9 0-112 50.1-112 112c0 23.6 7.3 45.6 19.8 63.6c6.9 10 15.5 18.9 25.2 26.2L216.4 244 88 280zM431.6 153.8c10.3 .9 20.7 .8 31-.5l17-2.1C476 183.1 448.9 208 416 208l-4.1 0c10.9-15.6 17.9-34.2 19.7-54.2zM360 152a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM293.5 307.5C289 341 263.5 370.8 226.7 380c-30.1 7.5-60-.8-80.7-19.1l-21.2 23.9c28.5 25.3 69.3 36.3 109.7 26.2c49.3-12.3 84.5-52.6 90.7-99.3l-31.7-4.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDuck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;